export default function roundTo(num, precision = 0) {
  const tenToPrecision = 10 ** precision;

  const result = Math.round(num * tenToPrecision) / tenToPrecision;

  if (isNaN(result)) console.warn("Invalid arguments passed to roundNumber");

  return result;
}
